const texts = {
  'pt-BR': {
    title: 'YT.Agent no WhatsApp',
    intro: 'Conecte seu WhatsApp para conversar com o YT.Agent.',
    loading: 'Consultando conexão...',
    connect: 'Conectar com WhatsApp',
    generating: 'Gerando código...',
    instructions:
      'Envie este código pelo WhatsApp que deseja vincular à sua conta.',
    code: 'Código de conexão',
    validity: 'Válido até',
    expired: 'Este código expirou. Gere um novo código para continuar.',
    copy: 'Copiar código',
    copied: 'Código copiado.',
    copyFailed:
      'Não foi possível copiar automaticamente. Selecione o código e copie manualmente.',
    send: 'Enviar código pelo WhatsApp',
    sendHelp:
      'O WhatsApp abrirá com o código preenchido. Toque em enviar para concluir essa etapa.',
    check: 'Já enviei — verificar conexão',
    checking: 'Verificando...',
    pending:
      'O vínculo ainda não foi confirmado. Envie o código pelo WhatsApp e verifique novamente.',
    regenerate: 'Gerar novo código',
    connected: 'WhatsApp conectado',
    connectedHelp: 'Seu WhatsApp está vinculado à sua conta Yellow Tokens.',
    talk: 'Conversar com o YT.Agent',
    disconnect: 'Desconectar',
    disconnecting: 'Desconectando...',
    confirmDisconnect:
      'Deseja desconectar seu WhatsApp? Será necessário gerar e enviar um novo código para vinculá-lo novamente.',
    confirm: 'Sim, desconectar',
    cancel: 'Cancelar',
    close: 'Fechar',
    retry: 'Tentar novamente',
    unauthorized: 'Sua sessão expirou ou é inválida. Entre novamente na Yellow Tokens.',
    forbidden: 'Seu acesso não foi autorizado para esta operação.',
    network: 'Não foi possível acessar a API. Verifique sua conexão e tente novamente.',
    generic: 'Não foi possível concluir a operação. Tente novamente.',
    invalidNumber: 'O número do YT.Agent não está configurado corretamente.',
    disconnected: 'WhatsApp desconectado.'
  },
  'en-US': {
    title: 'YT.Agent on WhatsApp',
    intro: 'Connect your WhatsApp to chat with YT.Agent.',
    loading: 'Checking connection...',
    connect: 'Connect with WhatsApp',
    generating: 'Generating code...',
    instructions:
      'Send this code from the WhatsApp account you want to link.',
    code: 'Connection code',
    validity: 'Valid until',
    expired: 'This code has expired. Generate a new code to continue.',
    copy: 'Copy code',
    copied: 'Code copied.',
    copyFailed:
      'Unable to copy automatically. Select the code and copy it manually.',
    send: 'Send code via WhatsApp',
    sendHelp:
      'WhatsApp will open with the code filled in. Tap send to complete this step.',
    check: 'Already sent — check connection',
    checking: 'Checking...',
    pending:
      'The connection has not been confirmed yet. Send the code via WhatsApp and check again.',
    regenerate: 'Generate new code',
    connected: 'WhatsApp connected',
    connectedHelp: 'Your WhatsApp is linked to your Yellow Tokens account.',
    talk: 'Chat with YT.Agent',
    disconnect: 'Disconnect',
    disconnecting: 'Disconnecting...',
    confirmDisconnect:
      'Disconnect your WhatsApp? You will need to generate and send a new code to link it again.',
    confirm: 'Yes, disconnect',
    cancel: 'Cancel',
    close: 'Close',
    retry: 'Try again',
    unauthorized: 'Your session has expired or is invalid. Sign in to Yellow Tokens again.',
    forbidden: 'You are not authorized to perform this operation.',
    network: 'Unable to reach the API. Check your connection and try again.',
    generic: 'Unable to complete the operation. Please try again.',
    invalidNumber: 'The YT.Agent phone number is not configured correctly.',
    disconnected: 'WhatsApp disconnected.'
  },
  esp: {
    title: 'YT.Agent en WhatsApp',
    intro: 'Conecta tu WhatsApp para conversar con YT.Agent.',
    loading: 'Consultando conexión...',
    connect: 'Conectar con WhatsApp',
    generating: 'Generando código...',
    instructions:
      'Envía este código desde el WhatsApp que deseas vincular a tu cuenta.',
    code: 'Código de conexión',
    validity: 'Válido hasta',
    expired: 'Este código ha caducado. Genera uno nuevo para continuar.',
    copy: 'Copiar código',
    copied: 'Código copiado.',
    copyFailed:
      'No se pudo copiar automáticamente. Selecciona el código y cópialo manualmente.',
    send: 'Enviar código por WhatsApp',
    sendHelp:
      'WhatsApp se abrirá con el código escrito. Pulsa enviar para completar este paso.',
    check: 'Ya lo envié — verificar conexión',
    checking: 'Verificando...',
    pending:
      'La conexión aún no se ha confirmado. Envía el código por WhatsApp y verifica nuevamente.',
    regenerate: 'Generar nuevo código',
    connected: 'WhatsApp conectado',
    connectedHelp: 'Tu WhatsApp está vinculado a tu cuenta Yellow Tokens.',
    talk: 'Conversar con YT.Agent',
    disconnect: 'Desconectar',
    disconnecting: 'Desconectando...',
    confirmDisconnect:
      '¿Deseas desconectar tu WhatsApp? Tendrás que generar y enviar un código nuevo para volver a vincularlo.',
    confirm: 'Sí, desconectar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    retry: 'Intentar de nuevo',
    unauthorized: 'Tu sesión ha caducado o no es válida. Inicia sesión nuevamente.',
    forbidden: 'No tienes autorización para realizar esta operación.',
    network: 'No se pudo acceder a la API. Revisa tu conexión e inténtalo de nuevo.',
    generic: 'No se pudo completar la operación. Inténtalo de nuevo.',
    invalidNumber: 'El número de YT.Agent no está configurado correctamente.',
    disconnected: 'WhatsApp desconectado.'
  }
};

export default texts;